import { useMemo, useState } from 'react';
import { useAuditLog } from '@/api/hooks';
import { AuditLogCard } from '@/components/AuditLogCard';
import { EMPTY_ACTIVITY_SEARCH, activitySearchFilters, type ActivitySearch } from '@/lib/activity';
import { apiMessage } from '@/lib/errors';

/**
 * A room's Activity feed: what people did, newest first. The search box, the date
 * range and "Show views and system activity" become server-side filters of the audit
 * list route, so every page is a full page of what they allow.
 */
export function RoomActivityFeed({ roomId }: { roomId: string }) {
  const [search, setSearch] = useState<ActivitySearch>(EMPTY_ACTIVITY_SEARCH);
  const filters = useMemo(() => activitySearchFilters(search), [search]);
  const auditLog = useAuditLog(roomId, filters);
  return (
    <AuditLogCard
      entries={auditLog.entries}
      loading={auditLog.isPending}
      error={apiMessage(auditLog.error)}
      hasOlder={auditLog.hasNextPage}
      loadingOlder={auditLog.isFetchingNextPage}
      onLoadOlder={() => void auditLog.fetchNextPage()}
      search={search}
      onSearchChange={setSearch}
    />
  );
}
